import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomConnector = styled(Box)({
  borderBottom: "1px solid #E2E8F0",
});
